/* NPM */
import { useEffect } from "react";
/* UTILS */
import { getCookieValue } from "../../../utils/cookies";
import { RESULTS_ELI_SEQUENCE } from "../../../utils/eligibility";
import { pageView, dispatchEvent } from "../../../utils/analytics";
import useAppContext from "../../AppContext";
import useUrlSlugContext from "../../UrlSlugContext";
/* COMPONENTS */
import ResultsJoinSequenceIneligible from "../ResultsJoinSequenceIneligible";
import ResultsJoinSequence from "../ResultsJoinSequence";

let eventSent = false;

const ResultsRestoredSequence = () => {
  const { newQuiz, setProfile } = useAppContext();
  const { setQueryString } = useUrlSlugContext();
  const resultPage = newQuiz?.isSequenceResultsScreen;

  useEffect(() => {
    pageView(`result-revisited`);
    const cookie = getCookieValue("ww_assessment", true);
    if (cookie?.profile) {
      setProfile(cookie?.profile);
    }
    if (cookie?.queryString) {
      setQueryString(cookie?.queryString);
    }
  }, []);

  useEffect(() => {
    if (eventSent) {
      return;
    }

    eventSent = true;
    dispatchEvent({
      event: "non_click_event",
      event_key: `quiz:result-revisited:${resultPage}`,
      event_category: "quiz",
      event_action: "quizResult",
      event_label: resultPage
    });
  }, [JSON.stringify(newQuiz)]);

  if (resultPage === RESULTS_ELI_SEQUENCE) {
    return <ResultsJoinSequence />;
  }

  return <ResultsJoinSequenceIneligible resultPage={resultPage} />;
};

export default ResultsRestoredSequence;
